import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';
import { AlarmAcknowledgementActions } from '../actions/alarm-action';

export const AlarmThunks = {
    AlarmAcknowledgement: (incidentId: number, organizationName: string, authHelper: AuthHelper): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(AlarmAcknowledgementActions.alarmAcknowledgementStarted());

        const payload = await ApiRequests.alarmAcknowledgement(
            { incidentId: incidentId, organizationName: organizationName },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(
                AlarmAcknowledgementActions.alarmAcknowledgementSucceeded(
                    payload.httpStatusCode,
                    payload.response.data.status,
                    payload.response.data.acknowledgeUser,
                    payload.response.data.acknowledgeTime
                )
            );
        } else {
            dispatch(AlarmAcknowledgementActions.alarmAcknowledgementFailed(payload.httpStatusCode));
        }
    },

    SierraAlarmAcknowledgement: (
        authHelper: AuthHelper,
        alarmId: string,
        deviceId: string,
        note: string
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(AlarmAcknowledgementActions.alarmAcknowledgementStarted());

        const payload = await ApiRequests.sierraAlarmAcknowledgement(
            { alarmId: alarmId, deviceId: deviceId, note: note },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(
                AlarmAcknowledgementActions.alarmAcknowledgementSucceeded(
                    payload.httpStatusCode,
                    payload.response.data.status,
                    payload.response.data.acknowledgeUser,
                    payload.response.data.acknowledgeTime
                )
            );
        } else {
            dispatch(AlarmAcknowledgementActions.alarmAcknowledgementFailed(payload.httpStatusCode));
        }
    },
    StarfishAlarmAcknowledgement: (
        authHelper: AuthHelper,
        alarmId: string,
        deviceId: string,
        note: string
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(AlarmAcknowledgementActions.alarmAcknowledgementStarted());

        const payload = await ApiRequests.starfishAlarmAcknowledgement(
            { alarmId: alarmId, deviceId: deviceId, note: note},
            { authHelper }
        );
         
        if (payload.ok) {
            dispatch(
                AlarmAcknowledgementActions.alarmAcknowledgementSucceeded(
                    payload.httpStatusCode,
                    payload.response.data.status,
                    payload.response.data.acknowledgeUser,
                    payload.response.data.acknowledgeTime
                )
            );
        } else {
            dispatch(AlarmAcknowledgementActions.alarmAcknowledgementFailed(payload.httpStatusCode));
        }
    },
};
